import Vuex from 'vuex'
import Vue from 'vue'
import { get, set, cloneDeep } from 'lodash'
import { fetchCountries, fetchRegions } from '../api/dataSets'
import CountryMapper from '@/js/lib/CountryMapper'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        countries: null,
        regions: null,
        user: null,
        userCountry: null,
        userAbTests: [],
    },
    mutations: {
        updateByPath: (state, { val, path }) => {
            const newState = cloneDeep(state)
            set(newState, path, val)
            Object.assign(state, newState)
        },
        setCountries: (state, countries) => {
            state.countries = countries
        },
        setRegions: (state, regions) => {
            state.regions = regions
        },
        setUser: (state, user) => {
            state.user = user
        },
        setUserCountry: async (state, userCountry) => {
            !state.userCountry && (state.userCountry = userCountry)
        },
        setUserAbTests: (state, abTestList) => {
            state.userAbTests = abTestList
        },
    },
    getters: {
        getValueByPath: state => path => {
            return get(state, path, null)
        },
        userAbTests: state => {
            return state.userAbTests
        },
    },
    actions: {
        fetchCountries: async ({ commit, state }) => {
            if (!state.countries || !state.countries.length) {
                const { data, error } = await fetchCountries()
                if (error) return
                if (data) {
                    commit('setCountries', data)
                }
            }
        },
        fetchRegions: async ({ commit, state }) => {
            if (!state.regions || !state.regions.length) {
                const { data, error } = await fetchRegions()
                if (error) return
                if (data) {
                    commit('setRegions', data)
                }
            }
        },
        setUserCountryByHeader: async ({ state, commit, dispatch, getters }, country) => {
            await dispatch('fetchCountries')
            const cMap = new CountryMapper(state.countries)
            const countryCode = cMap.swapCode(country)
            commit('setUserCountry', countryCode)
        },
    },
})

export default store
